export default __webpack_public_path__ + "static/media/home.00f098fd.png";